<template>
  <section class="content">
    <admin-header
      title="Vendor Zones"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
      :disableQuickSearch="true"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminVendorZone',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - Vendor Zones',
        searchEntityScreen: 'Admin - Vendor Zone search',
        filterEventName: 'admin-vendor-zone-filter',
        filterName: 'VendorZoneFilter',
        entityName: 'vendor-zone',
        transformFilterRequest: true
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/VendorZone/AdminVendorZone.vue